import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, useContext, watch } from '@nuxtjs/composition-api';

interface Props {
    side?: 'top' | 'right' | 'bottom' | 'left';
    type?: 'tonal' | 'outline',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Language',
  props: {
    side: { default: 'bottom' },
    type: { default: 'tonal' }
  },
  setup(__props: any) {

const props = __props as { side: 'top' | 'right' | 'bottom' | 'left', type: 'tonal' | 'outline' };



const {
    side,
    type,
} = toRefs(props);

const context = useContext();

const isOpen = ref(false);

const currentLocale = computed(() => context.i18n.locale);

const close = () => isOpen.value = false;

watch(isOpen, (val) => {
    if (val) {
        window.addEventListener('wheel', close, { once: true });
    } else {
        window.removeEventListener('wheel', close);
    }
}, { immediate: true });


return { __sfc: true,props, side, type, context, isOpen, currentLocale, close }
}

})